import { forwardRef } from 'react';
import { Button, Typography } from '@mui/joy';
import { Add } from '@mui/icons-material';

// Doubles as the empty state for a meal-type section (tall, "Add to breakfast")
// and as the always-present affordance to add more once something is planned
// (shorter, "Add another"). Forwards its ref so it can double as a dnd-kit
// drop target when dragging a meal onto this slot.
export const AddMealButton = forwardRef(function AddMealButton(
  { mealType, isEmpty, isOver = false, isDragging = false, onClick, compact = false },
  ref,
) {
  return (
    <Button
      ref={ref}
      variant="plain"
      color={compact ? 'neutral' : 'primary'}
      fullWidth
      startDecorator={<Add sx={{ fontSize: 16, color: 'inherit' }} />}
      onClick={onClick}
      sx={{
        '--Button-gap': '4px',        
        minHeight: compact ? 30 : (isEmpty ? 60 : 40),
        justifyContent: 'center',
        borderRadius: compact ? 'sm' : 'md',
        border: '1px dashed',
        borderColor: isDragging ? 'transparent' : 'var(--joy-palette-neutral-400)',
        color: compact ? 'var(--joy-palette-neutral-500)' : 'var(--joy-palette-primary-500)',
        outline: '2px dashed',
        outlineOffset: '-1px',
        outlineColor: isOver
          ? 'var(--joy-palette-primary-500)'
          : isDragging
            ? 'var(--joy-palette-neutral-400)'
            : 'transparent',
        backgroundColor: isOver ? 'var(--joy-palette-primary-50)' : isDragging ? '#fff' : 'transparent',
        transition: 'all 0.2s',
        '&:hover': {          
          backgroundColor: 'var(--joy-palette-primary-50)',
          borderColor: 'var(--joy-palette-primary-500)',   
          color: 'var(--joy-palette-primary-500)',                 
        },        
      }}
    >
      {!compact && (
        <Typography level="body-xs" sx={{ color: 'inherit' }}>
          {isEmpty ? `Add to ${mealType}` : 'Add another'}
        </Typography>
      )}
    </Button>
  );
});
